import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';

/** Requester only. Validates MIME type and size against `StorageOptions` server-side. */
export function useUploadTimeOffAttachment() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation({
    mutationFn: ({ requestId, file }: { requestId: string; file: File }) =>
      timeOffService.uploadAttachment(requestId, file),
    onSuccess: (_data, { requestId }) => {
      queryClient.invalidateQueries({ queryKey: TIME_OFF_KEYS.request(orgId, requestId) });
    },
  });
}
